var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm0 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm0-9.5a3.62 3.62 0 0 0-3.63 3.63 1 1 0 0 0 2 0 1.63 1.63 0 1 1 2.24 1.5C9.93 9.9 9 10.6 9 11.75V12a1 1 0 1 0 2 0c0-.24.05-.37.26-.47l.09-.04A3.63 3.63 0 0 0 10 4.5Z",
    fill: "#393B3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.5a3.62 3.62 0 0 0-3.63 3.63 1 1 0 0 0 2 0 1.63 1.63 0 1 1 2.24 1.5C9.93 9.9 9 10.6 9 11.75V12a1 1 0 1 0 2 0c0-.24.05-.37.26-.47l.09-.04A3.63 3.63 0 0 0 10 4.5ZM10 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    fill: "#A2A4A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.6e4df3028fdc23f315a9a29742d9ca44.svg";
export { ForwardRef as ReactComponent };